import { createFileRoute } from '@tanstack/react-router';
import DripEmailsPage from '../../views/dashboard-drip/emails';

export const Route = createFileRoute('/dashboard/drip/emails')({
  component: DripEmailsPage,
});
